import { createActions } from "redux-actions";

export const constants = {
  FETCH_LIST: "FETCH_LIST",
  UPDATE_DATE_FILTER: "UPDATE_DATE_FILTER",
  UPDATE_CALL_REPORTS_FILTERS: "UPDATE_CALL_REPORTS_FILTERS",
  RESET_CALL_REPORTS_FILTERS: "RESET_CALL_REPORTS_FILTERS",
  DELETE_CALL_REPORT: "DELETE_CALL_REPORT",
};

export const actions = createActions({
  FETCH_LIST: {
    REQUEST: ({ fromDate, toDate }) => ({ fromDate, toDate }),
    SUCCESS: (success) => success,
    FAILURE: (error) => error,
  },
  DELETE_CALL_REPORT: {
    REQUEST: ({ callReportId, userId }) => ({ callReportId, userId }),
    SUCCESS: (success) => success,
    FAILURE: (error) => error,
  },
  UPDATE_DATE_FILTER: ({ fromDate, toDate }) => ({ fromDate, toDate }),
});
